'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.async-iterator.js
// module id = 266
// module chunks = 0